<ng-template ngbModalContainer>
</ng-template>

<div>
  <emreg-header></emreg-header>
  <!--Page Content-->
  <div id="page-content-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <mrm-progress-bar></mrm-progress-bar>
        </div>
        <div class="col-sm-8 col-sm offset-2">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
  <!--/Page Content-->
</div>